import { User } from "../interfaces/User";

export const isAdministrator = (currentUser: User) => {
    return currentUser.roleName && (currentUser.roleName.toLowerCase() === "administrator");
}

export const isProjectlead = (currentUser: User) => {
        return currentUser.roleName && (currentUser.roleName.toLowerCase() === "administrator" || currentUser.roleName.toLowerCase() === "projektleiter");
}